import { registerModule } from '../../common/framework/service/module_service';

export function registerFrameworkModules() {
    // registerModule(new XrUiModule());
}
